// extracted by mini-css-extract-plugin
export default {"sectionHeaderBox":"SectionHeaderBox_sectionHeaderBox__uYvfn"};